module.exports = __webpack_public_path__ + "img/contact-us-arabic-01.b23dd20a.png";